import { render } from "./OfferedHeadCounts.vue?vue&type=template&id=af06dd9a"
import script from "./OfferedHeadCounts.vue?vue&type=script&lang=js"
export * from "./OfferedHeadCounts.vue?vue&type=script&lang=js"

import "./OfferedHeadCounts.vue?vue&type=style&index=0&id=af06dd9a&lang=css"

import exportComponent from "/home/runner/work/nutristudents-k12-container/nutristudents-k12-container/.vapor/build/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__